import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { SettingsForm } from "@/components/settings/settings-form";
import { adminSettingsQueryKey } from "@/lib/admin-queries";
import { adminApi } from "@/lib/api";

// The universal Settings tab (#240): reads the registry (metadata + current
// values) and lets the operator edit each field. A save PUTs one key and
// invalidates the query, so the form re-reads the persisted set and the change
// takes effect with no deploy.
function SettingsRoute() {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: adminSettingsQueryKey(),
    queryFn: () => adminApi.settings.list(),
  });
  const mutation = useMutation({
    mutationFn: ({ key, value }: { key: string; value: unknown }) =>
      adminApi.settings.update(key, value),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: adminSettingsQueryKey() }),
  });

  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="font-display text-2xl font-semibold tracking-tight">Ustawienia</h1>
        <p className="text-muted-foreground">
          Ustawienia produktu i zamówień — zmiana zaczyna działać od razu, bez wdrożenia.
        </p>
      </header>

      {query.isPending ? (
        <p className="text-sm text-muted-foreground">Ładowanie…</p>
      ) : query.isError ? (
        <p className="text-sm text-destructive">Nie udało się wczytać ustawień.</p>
      ) : (
        <SettingsForm
          fields={query.data.settings}
          onSave={async (key, value) => {
            await mutation.mutateAsync({ key, value });
          }}
        />
      )}
    </div>
  );
}

export const Route = createFileRoute("/settings/")({ component: SettingsRoute });
